export const mapVehicleType = (vehicleType: string): number => {
  switch (vehicleType) {
    case "C": // Cars
      return 1
    case "L": // Vans
      return 2
    // case 'tbc': Bikes
    default:
      return 1
  }
}
